import React, { createContext, useContext } from 'react';
import { initialState, useCartCalculate } from '../hooks/useCartCalculate';

const Context = createContext(initialState);

export const useCart = () => {
    const context = useContext(Context);
    
    if (!context) {
        throw new Error('Hook [useCart] must be inside [CartProvider].');
    }
    
    return context;
};

export const CartProvider = ({ children }) => {
    const state = useCartCalculate();
    
    return (
        <Context.Provider value={state}>
            {children}
        </Context.Provider>
    );
};
